import React from "react";
import { Trans } from "react-i18next";
import { UNIQUE_ID_GA } from "../../../../../constants/AppConstants";
import { ENVSettings } from "../../../../../constants/ENVSettings";

const BplusTermsAndConditionsLabel = (props) => {
    const { GAText } = props;
    const linkToTermsAndConditions= ENVSettings.BROTHER_CONNECT_TERMS_AND_CONDITIONS;
    const signup_privacyPolicy = `https://store.brother.co.uk/legals/privacy-policy`;
    
    return (
        <label htmlFor="brother-plus-terms-conditions">
            <Trans
                i18nKey="BROTHER_PLUS.EASY_PAY_BANNER.TERMS_AND_CONDITIONS_LABEL"
                components={[
                    /* eslint-disable-next-line */
                    <a
                    href={linkToTermsAndConditions}
                    target="_blank"
                    rel="noreferrer"
                    id={`${UNIQUE_ID_GA.signup}${GAText}`}
                    />,
                    /* eslint-disable-next-line */
                    <a 
                    href={signup_privacyPolicy} 
                    target="_blank" 
                    rel="noreferrer"
                    />
                ]}
            />
        </label>
    )
}

export default BplusTermsAndConditionsLabel;